<template>
  <div class="search-bar">
    <font-awesome-icon
      class="search-icon"
      icon="search"/>

    <input v-model="localValue" placeholder="Cerca..." type="text">

    <font-awesome-icon
      v-if="localValue"
      class="clear-icon"
      icon="times"
      @click="clear"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
  },

  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    clear() {
      this.localValue = '';
    },
  },
}
</script>

<style scoped>
.search-bar {
  margin: 15px 30px 15px 30px;
  /* width: 220px; */
  position: relative;
}

.search-icon {
  position: absolute;
  left: 9px;
  top: 6px;
  width: 16px;
  height: 22px;
  transform: scale(-1, 1);
}

.search-icon path {
  fill: #fff;
}

.search-bar input {
  width: 100%;
  height: 35px;
  border: 1px solid #ffb2b2;
  background-color: #b54141;
  padding-left: 35px;
  color: #fff;
}

.search-bar input::placeholder {
  color: #fff;
}

.clear-icon {
  position: absolute;
  right: 9px;
  top: 6px;
  width: 22px;
  height: 22px;
  cursor: pointer;
}
.clear-icon path {
  fill: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/Tree/SearchBar.vue